import React, { Component } from "react";
import { Outlet } from "react-router-dom";

class SetupIndex extends Component {
    render() {
        return (
            <React.Fragment>
                <main>
                    <Outlet />
                </main>
            </React.Fragment>
        )
    }
}

export default SetupIndex;